const attr = {
  link: 'data-back-to-plp-link'
}

// Collection and search pages, but not a product opened within a collection
const plpPathPattern = /\/(collections|search)(\/|$)/;

if (!customElements.get('back-to-plp')) {
  customElements.define('back-to-plp', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#clickHandle.bind(this));
    }

    #clickHandle(event) {
      const $link = event.target.closest(`[${attr.link}]`);
      if (!$link || !this.contains($link)) return;

      // Going back keeps the listing exactly as the customer left it
      // (scroll position, applied filters, already loaded pages).
      // Without a listing in the history the link href is followed instead.
      if (!this.#cameFromPlp()) return;

      event.preventDefault();
      history.back();
    }

    #cameFromPlp() {
      if (history.length <= 1 || !document.referrer) return false;

      let referrer;
      try {
        referrer = new URL(document.referrer);
      } catch {
        return false;
      }

      if (referrer.origin !== window.location.origin) return false;
      if (referrer.pathname.includes('/products/')) return false;

      return plpPathPattern.test(referrer.pathname);
    }
  })
}
